export default {
  select: 'id,fullName',
  expand: {
    position: {
      select: 'id,name',
    },
  },
  orderBy: 'fullName',
};
